



















import Vue from 'vue'
import { Profile3ElInterface } from '@/config/interfaces'
import axios from 'axios'

export default Vue.extend({
  name: 'Profile3',
  props: {
    templateItemData: {
      type: Object as () => Profile3ElInterface,
      required: true
    }
  },
  data: function () {
    return {
      uploadingImage: false
    }
  },
  computed: {
    profileImageStyle: function () {
      return `background-image: url(${this.templateItemData.imageUri}); background-size: cover; background-position: center center;`
    }
  },
  methods: {
    handleDeleteClick: function () {
      const uri = this.templateItemData.link2.action.uri
      if (uri) {
        this.uploadingImage = !this.uploadingImage
        axios.get(uri).then(() => {
          this.$router.back()
        }).catch(() => {
          this.uploadingImage = !this.uploadingImage
        })
      }
    },
    handleUploadClick: function () {
      const fileinput = this.$refs.fileinput as HTMLInputElement
      fileinput.click()
    },
    performUpload: function (e:Event) {
      const target = e.target as HTMLInputElement
      const file = target.files ? target.files[0] : null
      if (file !== null) {
        this.uploadingImage = !this.uploadingImage
        const formData = new FormData()
        formData.append('file', file)

        axios.post(this.templateItemData.link1.uploadUri, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(() => {
          this.$router.back()
        }).catch(() => {
          this.uploadingImage = !this.uploadingImage
        })
      }
    }
  }
})
